/* va-pack-lien.js - ouvre le configurateur sur un produit precis.
   Appele depuis une fiche produit : /pages/commander?pack=<handle>.

   18 septembre 2026 - REECRIT POUR LES PUBLICITES.
   Le probleme : un visiteur qui n'a pas encore de logo est envoye a l'etape
   du logo avant de voir la grille. L'ancienne version abandonnait apres 15 s,
   donc le client se retrouvait sur le site sans savoir ou etait son pack : il
   devait le rechercher a la main. Sur du trafic paye, ca se paie en conversions.

   Ce que fait cette version :
     1. Elle memorise le pack demande dans sessionStorage et nettoie l'URL tout
        de suite, pour que la cible survive a l'etape du logo.
     2. Elle attend la grille aussi longtemps qu'il faut (10 min), au lieu de 15 s.
     3. Si le visiteur finit son logo sur une autre page, elle le ramene sur
        /pages/commander des que le logo existe, et le pack s'ouvre la.
     4. Elle ne touche jamais a rien quand une fenetre est deja ouverte.

   Aucune modification de l'application. Si le DOM change, on retombe sur la page
   Commander, ce qui est le comportement d'avant. */
(function () {
  try {
    var CLE = 'va_pack_cible';
    var VIE = 10 * 60 * 1000;

    var params = new URLSearchParams(window.location.search);
    var demande = params.get('pack');
    if (demande) {
      try { sessionStorage.setItem(CLE, demande + '|' + Date.now()); } catch (e) {}
      try {
        params.delete('pack');
        var q = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : ''));
      } catch (e) {}
    }

    var brut = null;
    try { brut = sessionStorage.getItem(CLE); } catch (e) {}
    if (!brut) { return; }
    var bout = brut.split('|');
    var cible = bout[0];
    var pose = parseInt(bout[1], 10) || 0;
    if (!cible || Date.now() - pose > VIE) { oublie(); return; }

    function oublie() { try { sessionStorage.removeItem(CLE); } catch (e) {} }

    var debut = Date.now();
    var fait = false;
    var ongletFait = false;
    var pretDepuis = 0;
    var ONGLETS = { pack: ['Pack Combos', 'Packs'] };

    function surCommander() {
      return window.location.pathname.indexOf('/pages/commander') === 0;
    }

    /* Le logo est pose des que l'app en garde une trace, ou que le visiteur a
       choisi de continuer sans logo. */
    function logoPret() {
      try {
        if (localStorage.getItem('va_logo_name')) { return true; }
        if (localStorage.getItem('va_sans_logo')) { return true; }
        var L = localStorage.getItem('va_logos');
        if (L && L.length > 8) { return true; }
      } catch (e) {}
      return false;
    }

    function produit() {
      var L = window.__VA_PRODUCTS__ || [];
      for (var i = 0; i < L.length; i++) {
        if (L[i] && (L[i].id === cible || L[i].shopHandle === cible)) { return L[i]; }
      }
      return null;
    }

    function onglet(p) {
      if (ongletFait) { return true; }
      var libs = ONGLETS[p.category];
      if (!libs) { ongletFait = true; return true; }
      var els = document.querySelectorAll('button, a, [role="tab"]');
      for (var i = 0; i < els.length; i++) {
        var s = (els[i].textContent || '').trim();
        for (var j = 0; j < libs.length; j++) {
          if (s === libs[j]) { els[i].click(); ongletFait = true; return true; }
        }
      }
      if (Date.now() - debut > 4000) { ongletFait = true; return true; }
      return false;
    }

    function nomFichier(u) {
      try { return String(u).split('?')[0].split('/').pop(); } catch (e) { return ''; }
    }

    function bouton(p) {
      var img = nomFichier(p.image);
      var tous = document.querySelectorAll('button, a');
      for (var i = 0; i < tous.length; i++) {
        var b = tous[i];
        if (!/Personnaliser/.test(b.textContent || '')) { continue; }
        var n = b;
        for (var k = 0; k < 6 && n; k++) {
          if (n.querySelector) {
            var im = n.querySelector('img');
            if (im && img && (im.getAttribute('src') || '').indexOf(img) > -1) { return b; }
          }
          if (p.name && n.textContent && n.textContent.indexOf(p.name) > -1 &&
              n.querySelectorAll && n.querySelectorAll('button').length < 4) { return b; }
          n = n.parentElement;
        }
      }
      return null;
    }

    function essai() {
      if (fait) { return; }
      if (Date.now() - pose > VIE) { oublie(); return; }

      /* Une fenetre est ouverte : c'est peut-etre l'etape du logo, ou un choix
         du visiteur. On ne s'impose jamais par-dessus. */
      if (document.querySelector('[role="dialog"]')) { setTimeout(essai, 600); return; }

      if (!surCommander()) {
        /* Filet de securite seulement. Normalement l'app amene elle-meme le
           visiteur sur Commander une fois le logo pose ; on ne bouge que si elle
           ne l'a pas fait, et jamais pendant que l'etape du logo est a l'ecran -
           sinon on arracherait le visiteur en plein milieu. */
        if (logoPret()) {
          if (!pretDepuis) { pretDepuis = Date.now(); }
          var enCours = /Importe ton logo/i.test(document.body.innerText || '');
          if (!enCours && Date.now() - pretDepuis > 8000) {
            window.location.href = '/pages/commander';
            return;
          }
        } else {
          pretDepuis = 0;
        }
        setTimeout(essai, 600);
        return;
      }

      var p = produit();
      if (!p) { setTimeout(essai, 400); return; }
      if (!onglet(p)) { setTimeout(essai, 400); return; }
      var b = bouton(p);
      if (!b) { setTimeout(essai, 400); return; }
      fait = true;
      oublie();
      b.click();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(essai, 300); });
    } else {
      setTimeout(essai, 300);
    }
  } catch (e) {}
})();
